import { instantsInterceptor, } from '@/api/index';

function getSearchIndex(form) {
    return instantsInterceptor.post('/service/search/index', form);
}

function getSearchPdf(form) {
    return instantsInterceptor.post('/service/search/pdf', form);
}

function getSearchWebhelp(form) {
    return instantsInterceptor.post('/service/search/webhelp', form);
}

function getMainSearchCodes() {
    return instantsInterceptor.post('/service/search/codes');
}

function getMiddleProducts(prod_class) {
    return instantsInterceptor.post('/service/search/mprods', {pclass: prod_class} );
}

function getMainRecentDocument() {
    return instantsInterceptor.post('/main/search/recent');
}

function getSearchSuggestList(searchWord) {
    return instantsInterceptor.get('/service/search/suggest?term='+searchWord);
}


export { getSearchIndex, getSearchPdf, getSearchWebhelp, getMainSearchCodes, getMiddleProducts, getMainRecentDocument,getSearchSuggestList };